import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef, useCallback } from 'react';
import { Box } from '../../Box/index.js';
import 'react/jsx-runtime';
import 'react-helmet';
import '@emotion/react';
import { useLinkComponent } from '../../UIProvider/linkComponentContext.js';
import '@compono/ui-theme-compono';
import '../../hooks/useDetectInputMethod.js';
import '../../Toaster/Toaster.js';
import { useNavLinkComponent } from '../MainNavContext/index.js';
import { MainNavItemBody } from '../MainNavItemBody/index.js';
import { useMainNavItem } from '../useMainNavItem.js';

var MainNavLink = forwardRef(function (_a, forwardedRef) {
    var decor = _a.decor, description = _a.description, disabled = _a.disabled, icon = _a.icon, label = _a.label, notify = _a.notify, onClickProp = _a.onClick, props = __rest(_a, ["decor", "description", "disabled", "icon", "label", "notify", "onClick"]);
    var onClick = useCallback(function (event) {
        if (disabled) {
            event.preventDefault();
        }
        else {
            onClickProp && onClickProp(event);
        }
    }, [disabled, onClickProp]);
    var forwardProps = useMainNavItem(__assign(__assign({}, props), { onClick: onClick, disabled: disabled }));
    var navLinkComponent = useNavLinkComponent(forwardedRef);
    var linkComponent = useLinkComponent(forwardedRef);
    return (jsx(Box, __assign({ as: navLinkComponent || linkComponent, title: label }, forwardProps, (description && { "data-with-description": true }), { children: jsx(MainNavItemBody, { description: description, icon: icon, label: label, decor: decor, notify: notify }) })));
});
MainNavLink.displayName = "MainNavLink";

export { MainNavLink };
//# sourceMappingURL=index.js.map
